var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgXhand(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 94,
    viewBox: "0 0 74 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.6438 80.9981C46.6438 80.9981 45.9732 69.1704 45.8615 64.4762C45.7497 59.7819 45.8615 57.2113 45.8615 55.0877C45.8615 52.9641 44.5203 47.9346 44.0732 46.4816C43.6261 45.0286 42.5084 42.7933 42.5084 35.7519C42.5084 35.7519 42.3403 32.7342 42.1168 31.1131C41.8933 29.492 41.8933 27.1449 43.0109 25.9718C44.1286 24.7987 45.2463 24.6306 52.7347 24.686L54.4676 24.6771C54.4676 24.6771 56.8147 24.5743 57.429 27.9273C58.0432 31.2803 59.1055 33.2367 57.429 34.7451C55.7524 36.2535 51.7011 36.2902 51.6725 33.2573",
    stroke: "#F9BF2E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.7437 34.0192H48.5992C48.5992 34.0192 51.2262 34.131 51.9522 32.4545",
    stroke: "#F9BF2E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M51.9528 30.6107C51.9528 30.6107 51.7293 32.3445 52.847 33.2377",
    stroke: "#F9BF2E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M46.3643 29.4932C46.3643 29.4932 49.8568 32.4 52.0501 31.9243",
    stroke: "#F9BF2E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9674 24.6773C44.9674 24.6773 44.6321 22.2837 46.9238 21.6131C47.6114 21.4119 48.3901 21.1955 49.2074 20.9711C51.1137 20.4489 53.2337 19.8856 54.9147 19.3777C57.3181 18.6517 59.9442 18.4281 60.7266 20.9979C61.509 23.5677 63.2973 29.8839 62.3468 31.3923C61.3963 32.9007 60.6139 33.126 59.7198 33.2369C58.8257 33.3478 58.3303 32.957 58.3303 32.957",
    stroke: "#F9BF2E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M69.2765 23.2341C69.2765 23.2341 66.6495 24.7988 65.0847 23.2341C63.52 21.6693 61.7872 20.1046 61.6763 16.3045C61.5654 12.5044 63.5763 12.6162 64.5822 13.7902C65.5881 14.9642 67.8798 17.1432 69.2765 17.7584C70.6731 18.3735 72.0707 19.7147 72.127 21.503C72.1833 23.2913 72.406 28.936 72.6295 30.6125C72.853 32.289 72.127 33.5739 71.4564 34.8597C70.7858 36.1455 69.9471 39.1069 69.0529 42.2363C68.1588 45.3658 64.694 48.6071 64.694 52.519C64.694 56.4308 64.1915 63.5276 65.1965 69.3395C66.2015 75.1514 67.0214 78.466 67.1708 81",
    stroke: "#F9BF2E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M49.207 20.7188C49.207 20.7188 49.326 19.4331 51.0025 18.4281C52.679 17.423 54.132 15.8574 55.6967 14.6834C57.2614 13.5094 59.0497 11.4985 60.6699 12.1691C62.2901 12.8397 62.6182 13.2403 62.6182 13.2403",
    stroke: "#F9BF2E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M55.9127 14.5172C55.9127 14.5172 55.1938 12.0011 55.0257 11.275C54.8576 10.549 53.7399 7.02787 55.0257 5.57489C56.3115 4.12191 57.4846 3.67484 58.714 2.66894C59.9435 1.66303 61.2847 0.0982821 63.4637 1.66303C65.6427 3.22777 67.1708 4.28912 67.1708 4.28912C67.1708 4.28912 68.7543 5.35136 67.1708 6.9161C65.5873 8.48085 61.1729 7.81024 59.9989 6.13373",
    stroke: "#F9BF2E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M62.2353 7.75818C62.2353 7.75818 61.5791 9.87729 58.3306 9.09492C58.3306 9.09492 57.2612 8.70328 56.647 8.14534",
    stroke: "#F9BF2E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M61.6719 8.98315C61.6719 8.98315 61.9562 10.1008 62.2352 12.6715",
    stroke: "#F9BF2E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M62.6187 28.6543C62.6187 28.6543 65.4763 28.2072 65.8116 26.587C66.1469 24.9669 65.8116 23.7213 65.8116 23.7213",
    stroke: "#F9BF2E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M64.8933 27.804C64.8933 27.804 64.7135 28.5425 65.9609 30.2754",
    stroke: "#F9BF2E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M25 62.3672L30.332 52.5625H37.0703L28.7891 66.6641L37.2852 81H30.4688L25 71.0391L19.5312 81H12.7148L21.2109 66.6641L12.9297 52.5625H19.668L25 62.3672Z",
    fill: "url(#paint0_diamond)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_diamond",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.2424 69.8929) rotate(88.0754) scale(45.1147 45.0815)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD458",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9BF2E"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgXhand);
export default __webpack_public_path__ + "static/media/Xhand.a55d99ccc10fe3a0da6cd89ded882134.svg";
export { ForwardRef as ReactComponent };